import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 銷貨單 Excel 選列選項。
 * `GET /crm/sales-order/{id}/excel-options`
 *
 * @param {string} id
 */
export async function fetchSalesOrderExcelOptions(id) {
  const { data: raw } = await request.get(`/crm/sales-order/${id}/excel-options`);
  return parseVer4DetailResponse(raw);
}
